var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContratA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.81 73.1993C190.36 75.2393 183.9 77.2694 177.47 79.3094L53.21 41.9493C60.49 39.8293 67.75 37.6893 75.03 35.5693C115.63 48.1093 156.23 60.6593 196.81 73.1993Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.81 73.1992V239.029L177.47 250.449V79.3092L196.81 73.1992Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.21 41.9595V207.209L177.47 250.459V79.3195C136.04 66.8695 94.64 54.3995 53.21 41.9595ZM68.58 189.479V170.219C71.21 171.189 87.02 176.139 104.77 181.689L104.92 200.949C87.09 195.419 71.18 190.449 68.58 189.479ZM159.69 173.579C153.58 171.319 74.69 147.159 68.58 144.889V125.629C74.79 127.969 153.77 152.199 159.94 154.509C159.86 160.869 159.77 167.219 159.69 173.579ZM159.69 147.399C153.58 145.129 74.69 120.979 68.58 118.709V99.4395C74.79 101.779 153.77 126.009 159.94 128.319C159.86 134.679 159.77 141.029 159.69 147.389V147.399ZM159.69 122.779C153.58 120.509 74.69 96.3595 68.58 94.0895V74.8295C74.79 77.1395 153.77 101.399 159.94 103.709C159.86 110.069 159.77 116.419 159.69 122.779Z",
    fill: "#B2E8C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_1415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "translate(0.0100098 0.459473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratA);
export default __webpack_public_path__ + "static/media/contratA.8f303cab9745b08a1a0e42dad1c2ff0c.svg";
export { ForwardRef as ReactComponent };